export default __webpack_public_path__ + "static/media/plus-circle.2407f554.svg";